import { keyframes } from 'styled-components';
export var fadeIn = keyframes(["from{opacity:0;height:0;}to{opacity:1;height:70px;}"]);
export var fadeOut = keyframes(["from{opacity:1;height:70px;}to{opacity:0;height:0;}"]);